import { MantineColor } from '@mantine/core';

import { PracticalInformationDetailDtoTypeEnum } from 'src/Services/API/generated';

export interface CategoryColorConfig {
  mantineColor: MantineColor;
  hex: string;
}

// Mapping catégorie → couleur d'affichage. Le `hex` sert pour les bandes
// colorées en CSS inline ; le `mantineColor` sert pour les composants
// Mantine (Badge, Chip, etc.) qui attendent un nom de couleur du thème.
const CATEGORY_COLORS: Record<PracticalInformationDetailDtoTypeEnum, CategoryColorConfig> = {
  [PracticalInformationDetailDtoTypeEnum.GeneralInformation]: {
    mantineColor: 'gray',
    hex: '#868e96',
  },
  [PracticalInformationDetailDtoTypeEnum.SecurityAndAccess]: {
    mantineColor: 'orange',
    hex: '#fd7e14',
  },
  [PracticalInformationDetailDtoTypeEnum.ElectricityAndLighting]: {
    mantineColor: 'yellow',
    hex: '#fab005',
  },
  [PracticalInformationDetailDtoTypeEnum.WaterAndSanitation]: {
    mantineColor: 'cyan',
    hex: '#15aabf',
  },
  [PracticalInformationDetailDtoTypeEnum.HeatingAndAirConditioning]: {
    mantineColor: 'red',
    hex: '#fa5252',
  },
  [PracticalInformationDetailDtoTypeEnum.InternetAndMultimedia]: {
    mantineColor: 'indigo',
    hex: '#4c6ef5',
  },
  [PracticalInformationDetailDtoTypeEnum.MaintenanceAndStorage]: {
    mantineColor: 'teal',
    hex: '#12b886',
  },
  [PracticalInformationDetailDtoTypeEnum.LeisureAndSpecificEquipment]: {
    mantineColor: 'grape',
    hex: '#be4bdb',
  },
  [PracticalInformationDetailDtoTypeEnum.Custom]: {
    mantineColor: 'dark',
    hex: '#495057',
  },
};

// Ordre d'affichage des chips de filtre (cohérent avec la lecture
// fonctionnelle : généralités → sécurité → utilités → loisirs → custom).
export const CATEGORY_DISPLAY_ORDER: PracticalInformationDetailDtoTypeEnum[] = [
  PracticalInformationDetailDtoTypeEnum.GeneralInformation,
  PracticalInformationDetailDtoTypeEnum.SecurityAndAccess,
  PracticalInformationDetailDtoTypeEnum.ElectricityAndLighting,
  PracticalInformationDetailDtoTypeEnum.WaterAndSanitation,
  PracticalInformationDetailDtoTypeEnum.HeatingAndAirConditioning,
  PracticalInformationDetailDtoTypeEnum.InternetAndMultimedia,
  PracticalInformationDetailDtoTypeEnum.MaintenanceAndStorage,
  PracticalInformationDetailDtoTypeEnum.LeisureAndSpecificEquipment,
  PracticalInformationDetailDtoTypeEnum.Custom,
];

// Liste des valeurs valides — utilisée pour filtrer un query param URL
// potentiellement malformé avant de l'utiliser.
export const VALID_CATEGORY_VALUES = new Set<string>(CATEGORY_DISPLAY_ORDER);

// Renvoie la config couleur d'une catégorie. Fallback sur CUSTOM si la
// valeur est inconnue (cas où le back ajouterait une catégorie sans MAJ
// du front).
export const getCategoryColor = (type: string | undefined | null): CategoryColorConfig => {
  if (type && VALID_CATEGORY_VALUES.has(type)) {
    return CATEGORY_COLORS[type as PracticalInformationDetailDtoTypeEnum];
  }
  return CATEGORY_COLORS[PracticalInformationDetailDtoTypeEnum.Custom];
};
